import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseApiTemplateService, Core2Config, ApiVisa } from "../../shared";
import { BudgetGenericDocContainerModel } from "../../../../../../models/aggregates/erp/financial/budget-generic-doc-container.model";

@Injectable({
  providedIn: "root",
})
export class BudgetGenericDocService extends BaseApiTemplateService<BudgetGenericDocContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      "budget/gen-docs/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      "budget/gen-docs/backoffice-ep";
    this.httpClient = http;
  }
}
